export const {
  REACT_APP_BASE_URL,
  REACT_APP_HERMES_URL,
  REACT_APP_APOLLO_URL,
  REACT_APP_DOLOS_URL,
  REACT_APP_ENV,
  REACT_APP_BITBUCKET_BUILD_NUMBER,
  REACT_APP_SENTRY_URL,
} = process.env;
export const primaryColor = "#e86861";
export const secondaryColor = "#52d869";
export const authRoutes = ["login", "forgotPassword"];
export const hybridConsoles = ["wiseathena", "alen", "alenmayo"];
export const demoConsole = "demo";
export const SalesOut = "Cons. Rev";
export const SalesIn = "Ship. Sales";
export const SellOut = "Cons. Vol";
export const SellIn = "Shipments";
export const PriceOut = "Cons. Price";
export const PriceIn = "Ship. Price";
export const InvestmentIn = "Ship. Invest";
export const InvestmentOut = "Cons. Invest";
export const UnitsIn = "Ship. Volumen";
export const roi = "ROI";

export const kpisTerminology = (isUsaTerminology) => {
  if (isUsaTerminology)
    return {
      SellOut,
      SellIn,
      SalesOut,
      SalesIn,
      InvestmentIn,
      InvestmentOut,
      UnitsIn,
      PriceOut,
      Margin: "Margin",
      roi,
    };
  return {
    SellOut: "Sell Out",
    SellIn: "Sell In",
    SalesOut: "Sales Out",
    SalesIn: "Sales In",
    InvestmentIn: "Investment In",
    InvestmentOut: "Investment Out",
    UnitsIn: "Units In",
    PriceOut: "Price Out",
    Margin: "Margin",
    roi: "ROI",
  };
};
